import React from 'react';
import classNames from 'classnames';
import styles from './InputTextArea.module.scss';

interface IInputTextAreaProps {
  autoFocus?: boolean;
  className?: string;
  'data-test'?: string;
  disabled?: boolean;
  id?: string;
  isValid?: boolean;
  maxLength?: number;
  noResize?: boolean;
  onBlur?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  rows?: number;
  value: string;
}

export default function InputTextArea({
  autoFocus = false,
  className,
  disabled = false,
  id,
  isValid,
  maxLength,
  noResize = false,
  onBlur = () => {},
  onChange,
  onFocus = () => {},
  onKeyPress = () => {},
  placeholder,
  rows = 5,
  value = '',
}: IInputTextAreaProps) {
  const inputClasses = classNames(
    styles['a-input-text-area'],
    className,
    { [styles['-is-valid']]: isValid === true },
    { [styles['-is-invalid']]: isValid === false },
    { [styles['-no-resize']]: noResize === true },
  );
  return (
    <textarea
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={autoFocus}
      className={inputClasses}
      data-test="a-input-text-area"
      disabled={disabled}
      id={id || 'a-input-text-area'}
      maxLength={maxLength}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      onKeyPress={onKeyPress}
      placeholder={placeholder}
      rows={rows}
      value={value}
    />
  );
}
